import {$clientApi} from "../http";

class PaymentServiceClass {

    async buySubscription(model: any) {
        return $clientApi.post<{
            success: boolean,
            data: any,
            error?: {message: string}
        }>(`api/online-payment/order-details?`, model);
    }

    async buyAppointments(model: any, queryParams: string) {
        return $clientApi.post<{
            success: boolean,
            data: any,
            error?: {message: string}
        }>(`api/appointments/pay-with-stripe${queryParams}`, model);
    }

    async buyAppointmentBySubscription(model: any) {
        return $clientApi.post<{ appointmentId: number }>("api/appointments/pay-with-subscription", model);
    }

    async buyDropIn(model: any, queryParams: string) {
        return $clientApi.post<{
            success: boolean,
            data: any,
            error?: {message: string}
        }>(`api/drop-in/order-details${queryParams}`, model);
    }

    async buyVenues(model: any) {
        return $clientApi.post<{
            success: boolean,
            data?: any
        }>("api/room-reservation/book-rooms-pay-online", model);
    }

    async pay(model: any) {
        return $clientApi.post<any>(`api/online-payment/pay?api_version=2022-11-15`, model);
    }


}

export const PaymentService = new PaymentServiceClass();


